import "./index.css"

export const LeaderboardItem = () => {
    return(
        <div className="item-wrapper">
            
        </div>
    )
}